export default __webpack_public_path__ + "static/media/Emotion_Gratitude.6894b402.svg";